import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalDetails: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.Additional Details',
        defaultMessage: 'Additional Details'
    },
    namedNonOwner: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    hasPALeaseLoanCovButChangedOwnership: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.errorMessage.hasPALeaseLoanCovButChangedOwnership',
        defaultMessage: 'Unable to change from Financed as vehicle includes Lease Loan Gap coverage. Remove Lease Loan Gap coverage to continue.'
    },
    isFinanceWithoutPALeaseLoanCovButNoLienHolderOrLeaseButNoLessor: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.errorMessage.isFinanceWithoutPALeaseLoanCovButNoLienHolderOrLeaseButNoLessor',
        defaultMessage: 'Please update Owned/Financed/Leased field or add Interested Party Information.'
    },
    isOwnedButWithLienHolderLessor: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.errorMessage.isOwnedButWithLienHolderLessor',
        defaultMessage: 'Please update Owned/Financed/Leased field as Interested Party Information was added.'
    },
    isLeaseButNoLessor: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.errorMessage.isLeaseButNoLessor',
        defaultMessage: 'Please update Owned/Financed/Leased field or add Interested Party Information.'
    },
    uniqueEmailAddress: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.errorMessage.Each customer must have a unique email address.',
        defaultMessage: 'Each customer must have a unique email address.'
    },
    continueText: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.We\'ll review for any additional activity next and MVRs may be run',
        defaultMessage: 'We\'ll {reviewForAnyAdditionalActivityText} next and {mvrsMayBeRun}'
    },
    reviewForAnyAdditionalActivityText: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.review for any additional activity',
        defaultMessage: 'review for any additional activity'
    },
    mvrsMayBeRun: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.MVRs may be run',
        defaultMessage: 'MVRs may be run'
    },
    invalidEmail:{
        id:'ml.gatewayquoteandbind.pa.additionalInformation.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    duplicateLicenseError:{
        id:'ml.gatewayquoteandbind.pa.additionalInformation.License numbers must be unique',
        defaultMessage:"License numbers must be unique"
    },
    blockQuoteError: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.blockQuoteError',
        defaultMessage: 'Quote is ineligible. We are unable to continue with this quote.'
    },
    returnToQuote: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.Return to Quote',
        defaultMessage: 'Return to Quote'
    },
    calculatingQuote: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.calculatingQuote',
        defaultMessage: 'Calculating Quote...'
    },
    somethingWentWrong: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    duplicateSignalPhoneNumberMessage: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.duplicateSignalPhoneNumberMessage',
        defaultMessage: 'A different mobile phone number must be used for each driver that is selecting to participate in the Signal® program'
    },
    mvrDMVError: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.mvrDMVError',
        defaultMessage: 'The Department of Motor Vehicles cannot process the Motor Vehicle report due to Invalid Name, Gender, DOB or License Number.  Please verify these fields.'
    },
    mvrUnavailableError: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.mvrUnavailableError',
        defaultMessage: 'Motor Vehicle Record not available at this time, please try again later.'
    },
    coloradoMandates:{
        id:'ml.gatewayquoteandbind.pa.additionalInformation.colorado.coloradoMandates',
        defaultMessage: 'Colorado requires consent fields to be completed when optional coverages are selected. Please return to the submission, enter the required consent information, and then proceed with the policy purchase.'
    },
    coloradoMandatesAck:{
        id:'ml.gatewayquoteandbind.pa.additionalInformation.colorado.coloradoMandates.ack',
        defaultMessage: 'OK'
    },
    missingAnnualMileage: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.missingAnnualMileage',
        defaultMessage: 'Annual Mileage is required for this vehicle. Please navigate to the Vehicle Information screen to enter Annual Mileage before proceeding.'
    },
       requiredField: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.requiredField',
        defaultMessage: 'Mobile number is required when esignature options is selected as "Text"'
    },
      requiredFieldForEsignOptions: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.requiredFieldForEsignOptions',
        defaultMessage: 'Missing required field "eSignature Options"'
    },
     requiredFieldForEsign: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.requiredFieldForEsign',
        defaultMessage: ' Missing required field "eSign"'
    },
    requiredFieldEsignAck: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.requiredFieldEsignAck.',
        defaultMessage: 'Text Acknowledgement is required when esignature options is selected as "Text"'
    }

    
});
